import React from 'react';

import StateButton from 'app/general/widgets/StateButton';
import {markAllAsRead} from 'app/notifly/actions';
import {gt} from 'app/utils/i18n';

import {useAsyncActions} from '../../utils/redux';
type Props = {
  className?: string;
};

export default function MarkAllReadButton({className}: Props) {
  const actions = useAsyncActions({markAllAsRead});

  return (
    <StateButton
      className={`btn-primary btn-sm ${className || ''}`}
      onClick={actions.markAllAsRead}
      busyText={gt('Mark all as read')}
    >
      <i className="fa fa-check" /> {gt('Mark all as read')}
    </StateButton>
  );
}
